/* RC: GAD storefront redesign — desktop menu opens its children on hover (operator request
   2026-09-20). Dawn's mega/dropdown menus are <details> opened by click; on pointer devices we
   click the summary for it on mouseenter and close it on mouseleave (small delay so moving from
   the label into the panel does not close it). Touch and keyboard keep Dawn's click behaviour. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function bind(details) {
    if (details.dataset.rcHover) return;
    details.dataset.rcHover = '1';
    var summary = details.querySelector('summary');
    if (!summary) return;
    var closeTimer = null;

    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (window.innerWidth < 990) return;
      if (!details.hasAttribute('open')) summary.click();
    });
    details.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      if (window.innerWidth < 990) return;
      closeTimer = setTimeout(function () {
        if (details.hasAttribute('open')) summary.click();
      }, 160);
    });
    /* RC 2026-09-23 (operator): a real click on the parent label follows the parent's own link
       (children already open on hover). Synthetic clicks from the hover code are not trusted
       events and keep toggling the panel; keyboard and touch keep Dawn's behaviour. */
    summary.addEventListener('click', function (e) {
      if (!e.isTrusted || window.innerWidth < 990) return;
      var href = summary.getAttribute('data-rc-href');
      if (!href || href === '#') return;
      e.preventDefault();
      window.location.href = href;
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Footer sign-up thank-you (operator 2026-09-20, mockup 30 A1): the email typed into the sign-up form
   is kept for the redirect back; when the thank-you renders and a welcome-code endpoint is set, the
   one-time code is fetched and shown. No endpoint yet → the copy says the code comes by email. */
(function () {
  var form = document.getElementById('ContactFooter');
  if (form) {
    form.addEventListener('submit', function () {
      var e = form.querySelector('input[type="email"]');
      try { if (e && e.value) sessionStorage.setItem('rc_nl_email', e.value); } catch (err) {}
    });
  }
  var ok = document.querySelector('[data-rc-welcome]');
  if (!ok) return;
  var endpoint = ok.getAttribute('data-endpoint');
  var email = '';
  try { email = sessionStorage.getItem('rc_nl_email') || ''; } catch (err) {}
  if (!endpoint || !email) return;
  fetch(endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'email=' + encodeURIComponent(email), { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (!j || !j.code) return;
      var c = ok.querySelector('[data-rc-welcome-code]');
      var t = ok.querySelector('[data-rc-welcome-text]');
      c.textContent = j.code; c.hidden = false;
      if (t && t.getAttribute('data-with-code')) t.textContent = t.getAttribute('data-with-code');
      try { sessionStorage.removeItem('rc_nl_email'); } catch (err) {}
    })
    .catch(function () {});
})();

/* RC 2026-09-29: the Contact, Bulk & Department Orders and Request a web store forms send through Web3Forms when their
   key is set (Theme settings > RC forms, data-rc-w3f on the form). Field names lose Shopify's contact[...] wrapper so the
   email reads "Name: ...", the visitor's email becomes the reply-to, an empty file field is left out. Without a key the
   form stays Shopify's own contact form. */
(function () {
  var forms = document.querySelectorAll('form[data-rc-w3f]');
  Array.prototype.forEach.call(forms, function (f) {
    var key = f.getAttribute('data-rc-w3f');
    if (!key) return;
    function status(text, bad) {
      var s = f.querySelector('.rc-form__status');
      if (!s) { s = document.createElement('div'); f.insertBefore(s, f.firstElementChild); }
      s.className = 'rc-form__status' + (bad ? ' rc-form__status--error' : '');
      s.setAttribute('role', bad ? 'alert' : 'status');
      s.setAttribute('tabindex', '-1');
      s.textContent = text;
      s.focus();
      s.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (f.classList.contains('is-sending') || !f.reportValidity()) return;
      var src = new FormData(f), out = new FormData(), big = false;
      src.forEach(function (v) { if (typeof File !== 'undefined' && v instanceof File && v.size > 5 * 1024 * 1024) big = true; });
      if (big) { status('That logo file is over 5 MB. Please attach a smaller file, or send it later by email.', true); return; }
      src.forEach(function (v, k) {
        if (k === 'form_type' || k === 'utf8' || k === 'h-captcha-response' || k === 'g-recaptcha-response') return;  // Shopify's own captcha token means nothing to Web3Forms
        if (typeof File !== 'undefined' && v instanceof File && !v.size) return;
        var m = /^contact\[(.+)\]$/.exec(k);
        out.append(m ? m[1] : k, v);
      });
      out.append('access_key', key);
      out.append('subject', f.getAttribute('data-rc-w3f-subject') || 'Website form | gameappareldirect.com');
      out.append('from_name', 'Game Apparel Direct website');
      var mail = f.getAttribute('data-rc-w3f-mail') || 'info@gameappareldirect.com';
      f.classList.add('is-sending');
      fetch('https://api.web3forms.com/submit', { method: 'POST', body: out })  // no headers: the browser sets the multipart boundary (Web3Forms file-attachment doc)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.success) { f.reset(); status(f.getAttribute('data-rc-w3f-ok') || 'Thanks. We got your message.', false); }
          else status('That did not send. Please try again, or email ' + mail + '.', true);
        })
        .catch(function () { status('That did not send. Please try again, or email ' + mail + '.', true); })
        .then(function () { f.classList.remove('is-sending'); });
    });
  });
})();

/* Glass header (operator pick 2026-09-20): expose the header group's height so the hero can pull up
   under it, and flag the header the moment it sticks so the shrink starts right away (Dawn's own
   scrolled-past-header fires later, once the page has scrolled past the header's original bottom). */
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;
  var root = document.documentElement;
  /* RC 2026-09-23: measure the UNSHRUNK stack even when the page loads scrolled (reload, back,
     #demo links) - before, --rc-top-h stayed unset on such loads and the header pane collapsed to the
     strip, so the header went transparent (white page behind the menu) once the visitor scrolled
     back to the top. The shrink classes are lifted and transitions paused for one synchronous read. */
  function measure() {
    var wasStuck = header.classList.contains('rc-stuck'), wasPast = header.classList.contains('scrolled-past-header'), wasRoot = root.classList.contains('rc-header-stuck');
    root.classList.add('rc-measuring');
    header.classList.remove('rc-stuck', 'scrolled-past-header');
    root.classList.remove('rc-header-stuck');
    void header.offsetHeight;
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) { h += s.offsetHeight; });
    if (wasStuck) header.classList.add('rc-stuck');
    if (wasPast) header.classList.add('scrolled-past-header');
    if (wasRoot) root.classList.add('rc-header-stuck');
    void header.offsetHeight;
    root.classList.remove('rc-measuring');
    if (h > 0) root.style.setProperty('--rc-top-h', h + 'px');
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var stuck = window.scrollY > 4 && header.getBoundingClientRect().top <= 0;
      header.classList.toggle('rc-stuck', stuck);
      root.classList.toggle('rc-header-stuck', stuck);
      ticking = false;
    });
  }
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  document.addEventListener('shopify:section:load', function () { measure(); onScroll(); });
})();
